import { createContext, useContext, useState } from "react";

interface ExperienceContextType {
  novice: boolean;
  toggle: () => void;
}

const ExperienceContext = createContext<ExperienceContextType>({ novice: true, toggle: () => {} });

export function ExperienceProvider({ children }: { children: React.ReactNode }) {
  const [novice, setNovice] = useState(() => localStorage.getItem("iso27001.experience") !== "expert");

  function toggle() {
    setNovice((prev) => {
      const next = !prev;
      localStorage.setItem("iso27001.experience", next ? "novice" : "expert");
      return next;
    });
  }

  return <ExperienceContext.Provider value={{ novice, toggle }}>{children}</ExperienceContext.Provider>;
}

export function useExperience() {
  return useContext(ExperienceContext);
}
